<template>
  <div>
    <Consulta
        ref="filtroConsulta"
        titulo="Consulta de Nome Social"
        :consulta-callback="consulta"
        :parametros="paramsFiltro"
        :colunas="headers"
        :ordenacao-colunas="sortBy"

    >
      <template v-slot:areaParametros>
        <v-row dense>
          <v-col cols="6">
            <v-text-field
                v-model="paramsFiltro.nome"
                dense
                label="Nome"
                name="nomeInscricao"
                outlined
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field
                v-model="paramsFiltro.cpf"
                v-mask="'###########'"
                :counter="11"
                dense
                label="CPF"
                maxlength="11"
                name="cpfInscricao"
                outlined
            ></v-text-field>
          </v-col>
        </v-row>
      </template>
      <template v-slot:item.nomeSocialAprovado="{ item }">
        <div class="d-flex align-center">
          <v-select
              v-model="item.nomeSocialAprovado"
              :items="situacoes"
              hide-details
              dense
              outlined
              class="pa-2 w-50"
          ></v-select>

          <v-btn
              @click="salvarStatus(item)"
              color="primary"
              class="ml-2"
              small
          >
            Salvar
          </v-btn>
        </div>
      </template>

      <template v-slot:item.nomeSocial="{ item }">
        <v-edit-dialog
            :return-value.sync="item.nomeSocial"
            @save="salvarNomeSocial(item)"
            @cancel="reverterNomeSocial(item)"
            @open="item._backupNomeSocial = item.nomeSocial"
            large
            dense
            outlined
        >
          <div>{{ item.nomeSocial || '—' }}
            <v-icon left color="primary">mdi-pencil-outline
            </v-icon>
          </div>


          <template v-slot:input>
            <v-text-field
                v-model="item.nomeSocial"
                label="Nome Social"
                outlined
                dense
                hide-details
                autofocus
                class="ma-1 pa-1"
            ></v-text-field>
          </template>
        </v-edit-dialog>
      </template>

    </Consulta>
  </div>
</template>

<script>
import Consulta from "@/components/pages/admin/consultas/Consulta.vue";
import nomeSocialService from "@/services/nomeSocial.service";
import {mapActions} from "vuex";


export default {
  name: "AvaliarNomeSocial",
  components: {Consulta},
  data() {
    return {
      consulta: nomeSocialService.recuperarFiltro,
      headers: [
        {text: "Nome", value: "nome"},
        {text: "CPF", value: "cpf"},
        {text: "Nome Social Requerido", value: "nomeSocial"},
        {text: "Status", value: "nomeSocialAprovado"},

      ],
      sortBy: ["nomeSocialAprovado"],
      paramsFiltro: {},
      situacoes: [
        {value: 0, text: 'Aguardando aprovação' },
        {value : 1, text: 'Aprovado'},
        {value : 2 , text: 'Reprovado'}
    ]

    }
  },

  async mounted() {
    this.$refs.filtroConsulta.mostrarResultado = true;

    await this.$refs.filtroConsulta.consultar();

    },
  methods: {
    ...mapActions("avisos", ["exibirAviso"]),
     salvarNomeSocial(item) {
       nomeSocialService.atulizaNomeSocial(item)
    },
    async salvarStatus(item){
       let loader = this.$loading.show();
       await nomeSocialService.atulizaStatus(item).then(() => {
         this.$refs.filtroConsulta.getDataFromApi();
         this.exibirAviso({
           mensagem: item.nomeSocialAprovado ? "Nome Social Aprovado com sucesso!" : "Nome Social Reprovado!",
           tipo: "success"
         });
       }).catch(error => {
         let mensagem;
         if (error.response.status === 404) {
           mensagem = "Nome Social não foi salvo ";
         } else {
           mensagem = "Nome Social não foi salvo erro";
         }
         this.exibirAviso({
           mensagem: mensagem,
           tipo: "error"
         });
       });
       loader.hide()

    },
    reverterNomeSocial(item) {
      item.nomeSocial = item._backupNomeSocial;
    }
  }
  //colocar para funcionar , fazer um metodo para registrar a troca do Status do nome social
}
</script>

<style scoped>

</style>
